import React, { Component } from 'react';
import { connect } from 'react-redux';
import CustomSelect from "../../components/common/select/Select";
import ProductMiddleware from "../../store/prat_middleware/gt/productMiddleware";
import TargetTrackerMiddleware from "../../store/prat_middleware/targetTracker/targetTrackerMiddleware";
import { compare } from "../gt/validation/sort";
import TargetYTDBrandTable from './targetYTDBrandTable';
import TargetTotalSpentTable from './targetTotalSpentTable';
import './targetTracker.styles.scss';

class TargetTracker extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedProductCategories: [],
            selectedProductMasterSkus: [],
            selectedProductBrands: [],
            myBrands: [],
            myMasterSkus: []
        }
    };

    componentDidMount() {
        this.props.get_productMasterSkus();
        this.props.get_productBrands();
        this.props.get_productCategories();
        this.props.getTargetTrackerTotalSpent();
        this.props.getTargetTrackerYTDBrand(
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus
        );
        this.props.getTargetTrackerYTDBrandMTFTS(
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus
        );
        this.props.getTargetTrackerYTDBrandANP(
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus
        );
        this.props.getTargetTrackerDTTSBrand(
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus
        );
    };

    handleCategory = (category) => {
        let arr = [];
        if (category === null || category.length === 0) {
            this.setState({
                selectedProductCategories: [],
                selectedProductBrands: [],
                selectedProductMasterSkus: [],
                myBrands: [],
                myMasterSkus: [],
            });
        } else {
            category.forEach((element) => {
                arr.push(element.value);
            });

            this.setState({ selectedProductCategories: arr }, () => {
                this.handleFilteredBrands();
            });
        }
    };

    handleFilteredBrands = () => {
        const {
            selectedProductCategories,
            selectedProductBrands,
        } = this.state;
        const { product_brands } = this.props;
        let filteredbrands = [];
        if (selectedProductCategories.length) {
            for (let i = 0; i < selectedProductCategories.length; i++) {
                filteredbrands.push(
                    ...product_brands.filter((item) => {
                        return item.Category === selectedProductCategories[i];
                    })
                );
            }
            let arr = [];
            if (selectedProductBrands.length) {
                filteredbrands.forEach(item => {
                    if (selectedProductBrands.includes(item.guid)) {
                        arr.push(item.guid)
                    }
                })
                this.setState({ selectedProductBrands: arr });
            }
            this.setState({
                myBrands: filteredbrands,
            }, () => {
                this.handleFilteredMasterSku();
            });
        }
    };

    handleBrandChange = (selectedBrand) => {
        let arr = [];
        if (selectedBrand === null || selectedBrand.length === 0) {
            this.setState({
                selectedProductBrands: [],
                selectedProductMasterSkus: [],
                myMasterSkus: [],
            });
        } else {
            selectedBrand.forEach((e) => {
                arr.push(e.value);
            });

            this.setState({ selectedProductBrands: arr }, () => {
                this.handleFilteredMasterSku();
            });
        }
    };

    handleFilteredMasterSku = () => {
        const {
            selectedProductBrands,
            selectedProductMasterSkus
        } = this.state;
        const { product_master_skus } = this.props;
        let filteredSkus = [];
        if (selectedProductBrands.length) {
            for (let i = 0; i < selectedProductBrands.length; i++) {
                filteredSkus.push(
                    ...product_master_skus.filter((item) => {
                        return item.Brand === selectedProductBrands[i];
                    })
                );
            }

            let arr = [];
            if (selectedProductMasterSkus.length) {
                filteredSkus.forEach(item => {
                    if (selectedProductMasterSkus.includes(item.guid)) {
                        arr.push(item.guid)
                    }
                })
                this.setState({ selectedProductMasterSkus: arr });
            }
            this.setState({
                myMasterSkus: filteredSkus,
            });
        }
    };

    handleMasterSkusChange = (selectedMasterSku) => {
        let arr = [];
        if (selectedMasterSku === null || selectedMasterSku.length === 0) {
            this.setState({ selectedProductMasterSkus: [] });
        } else {
            selectedMasterSku.forEach((e) => {
                arr.push(e.value);
            });

            this.setState({ selectedProductMasterSkus: arr });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.getTargetTrackerYTDBrand(
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus
        );
        this.props.getTargetTrackerYTDBrandMTFTS(
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus
        );
        this.props.getTargetTrackerYTDBrandANP(
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus
        );
        this.props.getTargetTrackerDTTSBrand(
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus
        );
    };

    handleDownloadXlsxFile = () => {
        this.props.downloadTTXlx(
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus
        )
    };

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.targetTrackerYTDBrand !== this.props.targetTrackerYTDBrand) {
            // console.log(this.props.targetTrackerYTDBrand)
        }
    }

    render() {
        const { myBrands, myMasterSkus, selectedProductBrands, selectedProductCategories,
            selectedProductMasterSkus } = this.state;
        const { product_categories, isTargetTrackerYTDBrandLoading, targetTrackerYTDBrand,
            isTargetTrackerTotalSpentLoading, targetTrackerTotalSpent, isTTFileDownloading,
            isTargetTrackerYTDBrandANPLoading, targetTrackerYTDBrandANP, isTargetTrackerYTDBrandMTFTSLoading,
            targetTrackerYTDBrandMTFTS, isTargetTrackerDTTSBrandLoading, targetTrackerDTTSBrand } = this.props;
        return (
            <div className="page-container">
                <div className="heading-and-download-container">
                    <span className="component-heading">Target Tracker</span>

                    {isTTFileDownloading ? (
                        <img
                            alt=""
                            style={{ width: "26px", height: "31px" }}
                            src={require("../../assets/gifs/Downloading.gif")}
                        />
                    ) : (
                        <img
                            alt=""
                            style={{ cursor: "pointer" }}
                            src={require("../../assets/images/downloadIcon.svg")}
                            onClick={this.handleDownloadXlsxFile}
                        />
                    )}
                </div>

                <div className="select-container">
                    <div className="filters-container-only">
                        <CustomSelect.MyCustomSelect
                            placeholder={"Category"}
                            isDisabled={product_categories ? false : true}
                            allowSelectAll={true}
                            isMulti
                            options={
                                product_categories
                                    ? product_categories.sort(compare).map((item) => {
                                        return {
                                            value: item.guid,
                                            label: item.Name,
                                        };
                                    })
                                    : []
                            }
                            onChange={this.handleCategory}
                            value={
                                product_categories
                                    ? product_categories
                                        .filter((item) => {
                                            return selectedProductCategories.includes(
                                                item.guid
                                            );
                                        })
                                        .map((item) => {
                                            return {
                                                value: item.guid,
                                                label: item.Name,
                                            };
                                        })
                                    : []
                            }
                        />

                        <CustomSelect.MyCustomSelect
                            placeholder={"Brands"}
                            allowSelectAll={true}
                            isDisabled={myBrands.length ? false : true}
                            isMulti
                            options={
                                myBrands.length !== 0
                                    ? myBrands.sort(compare).map((item) => ({
                                        value: item.guid,
                                        label: item.Name,
                                    }))
                                    : []
                            }
                            onChange={this.handleBrandChange}
                            value={
                                myBrands.length !== 0 ?
                                    myBrands
                                        .filter((item) => {
                                            return selectedProductBrands.includes(item.guid);
                                        })
                                        .map((item) => {
                                            return {
                                                value: item.guid,
                                                label: item.Name,
                                            };
                                        })
                                    :
                                    []
                            }
                        />

                        <CustomSelect.MyCustomSelect
                            placeholder={"MSKUs"}
                            allowSelectAll={true}
                            isDisabled={myMasterSkus.length ? false : true}
                            isMulti
                            options={
                                myMasterSkus.length !== 0
                                    ? myMasterSkus.sort(compare).map((item) => ({
                                        value: item.guid,
                                        label: item.Description,
                                    }))
                                    : []
                            }
                            onChange={this.handleMasterSkusChange}
                            value={
                                myMasterSkus.length !== 0 ?
                                    myMasterSkus
                                        .filter((item) => {
                                            return selectedProductMasterSkus.includes(item.guid);
                                        })
                                        .map((item) => {
                                            return {
                                                value: item.guid,
                                                label: item.Description,
                                            };
                                        })
                                    :
                                    []
                            }
                        />
                    </div>

                    <button
                        className="submit-btn"
                        onClick={(e) => this.handleSubmit(e)}
                    >
                        SUBMIT
                    </button>
                </div>

                <div className='table-container-div' style={{ marginBottom: '8px' }}>
                    <div className='table-container-div-heading'>
                        YTD - BRANDS (GT)
                    </div>
                    {
                        isTargetTrackerYTDBrandLoading ?
                            <img src={require('../../assets/images/barsLoader.svg')} alt="" style={{ width: '60px', height: '60px' }} />
                            :
                            <>
                                {
                                    targetTrackerYTDBrand && !targetTrackerYTDBrand.length
                                        ?
                                        <div>No Data Found!</div>
                                        :
                                        <TargetYTDBrandTable
                                            tableData={targetTrackerYTDBrand}
                                            showTotalCol={true}
                                        />
                                }
                            </>
                    }
                </div>

                <div className='table-container-div' style={{ marginBottom: '8px' }}>
                    <div className='table-container-div-heading'>
                        YTD - BRANDS (MTFTS)
                    </div>
                    {
                        isTargetTrackerYTDBrandMTFTSLoading ?
                            <img src={require('../../assets/images/barsLoader.svg')} alt="" style={{ width: '60px', height: '60px' }} />
                            :
                            <>
                                {
                                    targetTrackerYTDBrandMTFTS && !targetTrackerYTDBrandMTFTS.length
                                        ?
                                        <div>No Data Found!</div>
                                        :
                                        <TargetYTDBrandTable
                                            tableData={targetTrackerYTDBrandMTFTS}
                                            showTotalCol={true}
                                        />
                                }
                            </>
                    }
                </div>

                <div className='table-container-div' style={{ marginBottom: '8px' }}>
                    <div className='table-container-div-heading'>
                        YTD - BRANDS (ANP)
                    </div>
                    {
                        isTargetTrackerYTDBrandANPLoading ?
                            <img src={require('../../assets/images/barsLoader.svg')} alt="" style={{ width: '60px', height: '60px' }} />
                            :
                            <>
                                {
                                    targetTrackerYTDBrandANP && !targetTrackerYTDBrandANP.length
                                        ?
                                        <div>No Data Found!</div>
                                        :
                                        <TargetYTDBrandTable
                                            tableData={targetTrackerYTDBrandANP}
                                            showTotalCol={true}
                                        />
                                }
                            </>
                    }
                </div>

                <div className='table-container-div' style={{ marginBottom: '8px' }}>
                    <div className='table-container-div-heading'>
                        DTTS - BRANDS
                    </div>
                    {
                        isTargetTrackerDTTSBrandLoading ?
                            <img src={require('../../assets/images/barsLoader.svg')} alt="" style={{ width: '60px', height: '60px' }} />
                            :
                            <>
                                {
                                    targetTrackerDTTSBrand && !targetTrackerDTTSBrand.length
                                        ?
                                        <div>No Data Found!</div>
                                        :
                                        <TargetYTDBrandTable
                                            tableData={targetTrackerDTTSBrand}
                                            showTotalCol={false}
                                        />
                                }
                            </>
                    }
                </div>

                <div className='table-container-div'>
                    <div className='table-container-div-heading'>
                        Total Spent
                    </div>
                    {
                        isTargetTrackerTotalSpentLoading ?
                            <img src={require('../../assets/images/barsLoader.svg')} alt="" style={{ width: '60px', height: '60px' }} />
                            :
                            <>
                                {
                                    targetTrackerTotalSpent && !targetTrackerTotalSpent.length
                                        ?
                                        <div>No Data Found!</div>
                                        :
                                        <TargetTotalSpentTable
                                            tableData={targetTrackerTotalSpent}
                                        />
                                }
                            </>
                    }
                </div>

            </div>
        );
    }
};


const mapStateToProps = state => {
    return {
        product_categories: state.ProductReducer.productCategories,
        product_brands: state.ProductReducer.productBrands,
        product_master_skus: state.ProductReducer.productMasterSkus,
        isTargetTrackerYTDBrandLoading: state.TargetTrackerReducer.isTargetTrackerYTDBrandLoading,
        targetTrackerYTDBrand: state.TargetTrackerReducer.targetTrackerYTDBrand,
        isTargetTrackerTotalSpentLoading: state.TargetTrackerReducer.isTargetTrackerTotalSpentLoading,
        targetTrackerTotalSpent: state.TargetTrackerReducer.targetTrackerTotalSpent,
        isTTFileDownloading: state.TargetTrackerReducer.isTTFileDownloading,
        isTargetTrackerYTDBrandMTFTSLoading: state.TargetTrackerReducer.isTargetTrackerYTDBrandMTFTSLoading,
        targetTrackerYTDBrandMTFTS: state.TargetTrackerReducer.targetTrackerYTDBrandMTFTS,
        isTargetTrackerYTDBrandANPLoading: state.TargetTrackerReducer.isTargetTrackerYTDBrandANPLoading,
        targetTrackerYTDBrandANP: state.TargetTrackerReducer.targetTrackerYTDBrandANP,
        isTargetTrackerDTTSBrandLoading: state.TargetTrackerReducer.isTargetTrackerDTTSBrandLoading,
        targetTrackerDTTSBrand: state.TargetTrackerReducer.targetTrackerDTTSBrand,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        get_productCategories: () => {
            return dispatch(ProductMiddleware.get_categories());
        },
        get_productBrands: () => {
            return dispatch(ProductMiddleware.get_brands());
        },
        get_productMasterSkus: () => {
            return dispatch(ProductMiddleware.get_master_skus());
        },
        getTargetTrackerYTDBrand: (
            selectedProductCategories,
            selectedProductBrands,
            selectedProductMasterSkus
        ) => {
            return dispatch(TargetTrackerMiddleware.getTargetTrackerYTDBrand(
                selectedProductCategories,
                selectedProductBrands,
                selectedProductMasterSkus
            ));
        },
        getTargetTrackerYTDBrandMTFTS: (
            selectedProductCategories,
            selectedProductBrands,
            selectedProductMasterSkus
        ) => {
            return dispatch(TargetTrackerMiddleware.getTargetTrackerYTDBrandMTFTS(
                selectedProductCategories,
                selectedProductBrands,
                selectedProductMasterSkus
            ));
        },
        getTargetTrackerYTDBrandANP: (
            selectedProductCategories,
            selectedProductBrands,
            selectedProductMasterSkus
        ) => {
            return dispatch(TargetTrackerMiddleware.getTargetTrackerYTDBrandANP(
                selectedProductCategories,
                selectedProductBrands,
                selectedProductMasterSkus
            ));
        },
        getTargetTrackerTotalSpent: () => {
            return dispatch(TargetTrackerMiddleware.getTargetTrackerTotalSpent());
        },
        downloadTTXlx: (
            selectedProductCategories,
            selectedProductBrands,
            selectedProductMasterSkus
        ) => {
            return dispatch(TargetTrackerMiddleware.downloadTTXlx(
                selectedProductCategories,
                selectedProductBrands,
                selectedProductMasterSkus
            ));
        },
        getTargetTrackerDTTSBrand: (
            selectedProductCategories,
            selectedProductBrands,
            selectedProductMasterSkus
        ) => {
            return dispatch(TargetTrackerMiddleware.getTargetTrackerDTTSBrand(
                selectedProductCategories,
                selectedProductBrands,
                selectedProductMasterSkus
            ));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TargetTracker);